import zipObjects from './zipObjects';

const objectsDiff = (objA, objB, comparatorFunc) => {
  const zippedObj = zipObjects(objA, objB);
  return Object.entries(zippedObj).reduce((diffObj, [key, [valA, valB]]) => {
    if (!comparatorFunc(valA, valB, key)) {
      diffObj[key] = [valA, valB];
    }
    return diffObj;
  }, {});
};

export default objectsDiff;
